import styled, { css } from 'styled-components';

export const printHiddenCss = css`
  @media print {
    display: none;
    width: auto;
    border: 0;
    margin: 0;
    padding: 0;
    float: none;
    overflow: visible;
  }
`;

export const PrintHidden = styled.span`
  ${printHiddenCss};
`;
